import { render, staticRenderFns } from "./ItemRating.vue?vue&type=template&id=9ecb51c6&scoped=true&"
import script from "./ItemRating.vue?vue&type=script&lang=ts&"
export * from "./ItemRating.vue?vue&type=script&lang=ts&"
import style0 from "./ItemRating.vue?vue&type=style&index=0&id=9ecb51c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecb51c6",
  null
  
)

export default component.exports